import { render } from "./ChooseContact.vue?vue&type=template&id=0689f95f&scoped=true"
import script from "./ChooseContact.vue?vue&type=script&lang=js"
export * from "./ChooseContact.vue?vue&type=script&lang=js"

import "./ChooseContact.vue?vue&type=style&index=0&id=0689f95f&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0689f95f"

export default script